export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/threeD_product_animation.6f21ef1.svg";